import React, { Component } from "react";
import PropsType from "prop-types";
import styles from "./_style";
import DateCore from "./_gears/DateCore";
import YearCore from "./_gears/YearCore";
import MonthCore from "./_gears/MonthCore";
import YearMonthSelector from "./_gears/YearMonthSelector";
import { OperBar } from "IZOX/BLOCKS/Libs";
import { GState, ZTime } from "IZOX/STATIC";
import { VStack } from "IZOX/_X";
import { observer } from "mobx-react";
import _ from "lodash";

/**
 * @augments {Component<Props, State>}
 */
class CalendarizoC extends Component {

  static propTypes = {

    width: PropsType.oneOfType([PropsType.number, PropsType.string]), 
    height: PropsType.oneOfType([PropsType.number, PropsType.string]), 

    valDate: PropsType.string,
    valStart: PropsType.string,
    valEnd: PropsType.string,
    valDates: PropsType.array,
    
    minDate: PropsType.string,
    maxDate: PropsType.string,
    minRange: PropsType.number,
    maxRange: PropsType.number,
    validFunc: PropsType.func,

    selectType: PropsType.oneOf(["date", "week", "month", "year"]),
    range: PropsType.bool,

    dayOfWeekBar: PropsType.bool,
    weekendHighlight: PropsType.bool,

    directConfirm: PropsType.bool,

    onConfirm: PropsType.func,
    onCancel: PropsType.func,

    styleSet: PropsType.string,

    size: PropsType.number,
    style: PropsType.any,

    defaultDisMonth: PropsType.number,
    defaultDisYear: PropsType.number,

    readOnly: PropsType.bool,
    multiple: PropsType.bool,

    onSelectorChange: PropsType.func,
    dayCellDecorator: PropsType.func
  };

  static defaultProps = {
    valDate: null,
    valStart: null,
    valEnd: null,
    valDates: [],
    
    minDate: ZTime.Moment(new Date(1970, 0, 1)).toISOString(),
    maxDate: ZTime.Moment(new Date(2200, 11, 31)).toISOString(),
    minRange: 0,
    maxRange: Infinity,
    validFunc: (date, rangeMode, curValue) => true,

    selectType: "date",
    range: false,

    dayOfWeekBar: true,
    weekendHighlight: true,

    directConfirm: true,

    onConfirm: null,
    onCancel: null,

    size: 40,
    style: {},

    defaultDisMonth: ZTime.Now().local().month(),
    defaultDisYear: ZTime.Now().local().year(),

    readOnly: false,
    multiple: false,
    onSelectorChange: null,
    dayCellDecorator: null
  };

  constructor(props){
    let {valDate, valStart, valEnd, defaultDisMonth, defaultDisYear, valDates} = props;

    if(valDate){
      defaultDisMonth = ZTime.Moment(valDate).local().month();
      defaultDisYear = ZTime.Moment(valDate).local().year();
    }else if(valStart){
      defaultDisMonth = ZTime.Moment(valStart).local().month();
      defaultDisYear = ZTime.Moment(valStart).local().year();
    }else if(valDates && valDates.length > 0){
      defaultDisMonth = ZTime.Moment(valDates[0]).local().month();
      defaultDisYear = ZTime.Moment(valDates[0]).local().year();
    }

    if(defaultDisYear < 1970){
      defaultDisYear = 1970;
    }else if(defaultDisYear > 3000){
      defaultDisYear = 3000;
    }

    super();
    this.state = {
      disYear: defaultDisYear,
      disMonth: defaultDisMonth,
      coreMode: "date",
      selectedDate: valDate ?? "",
      selectedStart: valStart ?? "",
      selectedEnd: valEnd ??"",
      selectedDates: valDates ?? [],
      rangeMode: "start"
    };
  }

  componentDidMount(){
    this._setAllStates(() => {
      this._setDefault();
    });
  }

  // componentDidUpdate(prevProps, prevState){
    // if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(CalendarizoC.defaultProps))){
    //   this._setAllStates(() => {
    //     this._setDefault();
    //   });
    // }
  // }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  _GetStyle = () => {
    return styles[GState.darkMode ? "dark" : "normal"] ?? {};
  }

  _validFallback = () => {
    let {disYear, disMonth} = this.state;
    let _fixYear = disYear;
    let _fixMonth = disMonth;
    if(_.isNaN(disYear)){
      _fixYear = ZTime.Now().year();
    }
    if(_.isNaN(disMonth)){
      _fixMonth = ZTime.Now().month();
    }
    if(_fixYear < 1970){
      _fixYear = 1970;
    }
    if(_fixYear > 3000){
      _fixYear = 3000;
    }
    if(_fixMonth < 0){
      _fixMonth = 0;
    }
    if(_fixMonth > 11){
      _fixMonth = 11;
    }
    this.setState({
      disYear: _fixYear,
      disMonth: _fixMonth
    });
  }

  _setDefault = () => {
    let {range, valDate, valStart, valEnd, valDates,
      defaultDisMonth, defaultDisYear, multiple} = this.props;
    if(range){
      this.setState({
        selectedStart: valStart ?? "",
        selectedEnd: valEnd ?? "",
        disYear: valStart ? ZTime.Moment(valStart).local().year() : defaultDisYear,
        disMonth: valStart ? ZTime.Moment(valStart).local().month() : defaultDisMonth,
      }, () => this._validFallback());
    }else if(multiple){
      this.setState({
        selectedDates: valDates ?? [],
        disYear: valDates?.[0] ? ZTime.Moment(valDates?.[0]).local().year() : defaultDisYear,
        disMonth: valDates?.[0] ? ZTime.Moment(valDates?.[0]).local().month() : defaultDisMonth,
      }, () => this._validFallback());
    }else{
      this.setState({
        selectedDate: valDate ?? "",
        disYear: valDate ? ZTime.Moment(valDate).local().year() : defaultDisYear,
        disMonth: valDate ? ZTime.Moment(valDate).local().month() : defaultDisMonth,
      }, () => this._validFallback());
    }
  };

  _isValidYear = (year) => {
    let {minDate, maxDate} = this.props;
    let checkO = ZTime.Moment(new Date(year, 0, 1));
    let start = ZTime.StartOfYear(checkO, null).toISOString();
    let end = ZTime.EndOfYear(checkO, null).toISOString();

    return ZTime.IsOverlap(minDate, maxDate, start, end);
  };

  _isValidMonth = (year, month) => {
    let {minDate, maxDate} = this.props;
    let checkO = ZTime.Moment(new Date(year, month, 1));
    let start = ZTime.StartOfMonth(checkO, null).toISOString();
    let end = ZTime.EndOfMonth(checkO, null).toISOString();

    return ZTime.IsOverlap(minDate, maxDate, start, end);
  };

  _isValid = (year, month, date) => {
    let {minDate, maxDate, range, minRange, maxRange, validFunc} = this.props;
    let {rangeMode, selectedStart, selectedDate, selectedEnd} = this.state;
    let checkO = ZTime.Moment(new Date(year, month, date));

    if(range && rangeMode === "end"){
      return ZTime.IsBetween(checkO, 
        minRange > 0 ? ZTime.Moment(selectedStart).add(minRange, "days") : ZTime.Moment(selectedStart), 
        ZTime.Min(maxRange < Infinity? ZTime.Moment(selectedStart).add(maxRange, "days") : maxDate, maxDate), "[]");
    }

    return ZTime.IsBetween(checkO, minDate, maxDate, "[]")
      && validFunc?.(checkO.toISOString(), rangeMode, {selectedStart, selectedEnd, selectedDate});
  };

  setCoreMode = (mode) => {
    this.setState({
      coreMode: mode
    });
  };

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  };

  _onConfirm = () => {
    let {onConfirm, range, selectType, multiple} = this.props;
    let {selectedDate, selectedStart, selectedEnd, selectedDates} = this.state;
    if(!range && selectType === "date" && !multiple){
      onConfirm?.(selectedDate);
    }else if(multiple){
      onConfirm?.(selectedDates);
    }else{
      onConfirm?.({
        start: selectedStart,
        end: selectedEnd
      });
    }
  };

  _onCancel = () => {
    let {onCancel, addOns} = this.props;
    onCancel?.(addOns);
  };

  _onSelectorChange = (year, month) => {
    let {minDate, maxDate, onSelectorChange} = this.props;
    let {coreMode} = this.state;

    let date = ZTime.Moment(new Date(year, month, 1));
    if(date.isBefore(minDate)){
      date = ZTime.Moment(minDate);
    }
    if(date.isAfter(maxDate)){
      date = ZTime.Moment(maxDate);
    }

    year = date.local().year();
    month = date.local().month();

    onSelectorChange?.(year, month);

    this.setState({
      disYear: year, 
      disMonth: month,
      coreMode: coreMode === "year" ? "month" : "date"
    });
  };

  _afterSelect = () => {
    let {directConfirm, multiple} = this.props;
    if(directConfirm && !multiple){
      this._onConfirm();
    }
  }

  _onDateSelect = (date) => {
    let {multiple, range, readOnly} = this.props;
    let {selectType, rangeMode, selectedDates} = this.state;
    if(!this._isValid(date.year(), date.month(), date.date())) return;
    if(readOnly) return;

    if(range){
      switch(selectType){
        default: case "date":
          if(rangeMode === "start"){
            this.setState({
              selectedStart: ZTime.StartOfDay(date, null).toISOString(),
              selectedEnd: "",
              rangeMode: "end"
            });
          }else{
            this.setState({
              selectedEnd: ZTime.EndOfDay(date, null).toISOString(),
              rangeMode: "start"
            }, this._afterSelect);
          }
          break;
        case "week":
          if(rangeMode === "start"){
            this.setState({
              selectedStart: ZTime.StartOfWeek(date, null).toISOString(),
              selectedEnd: "",
              rangeMode: "end"
            });
          }else{
            this.setState({
              selectedEnd: ZTime.EndOfWeek(date, null).toISOString(),
              rangeMode: "start"
            }, this._afterSelect);
          }
          break;
        case "month":
          if(rangeMode === "start"){
            this.setState({
              selectedStart: ZTime.StartOfMonth(date, null).toISOString(),
              selectedEnd: "",
              rangeMode: "end"
            });
          }else{
            this.setState({
              selectedEnd: ZTime.EndOfMonth(date, null).toISOString(),
              rangeMode: "start"
            }, this._afterSelect);
          }
          break;
        case "year":
          if(rangeMode === "start"){
            this.setState({
              selectedStart: ZTime.StartOfYear(date, null).toISOString(),
              selectedEnd: "",
              rangeMode: "end"
            });
          }else{
            this.setState({
              selectedEnd: ZTime.EndOfYear(date, null).toISOString(),
              rangeMode: "start"
            }, this._afterSelect);
          }
          break;
      }
    }else if(multiple){
      switch(selectType){
        default: case "date":
          let _date = date.toISOString();
          if(selectedDates.includes(_date)){
            selectedDates = _.filter(selectedDates, (o) => o !== _date);
          }else{
            selectedDates.push(_date);
          }
          this.setState({
            selectedDates: selectedDates
          }, this._afterSelect);
          break;
      }   
    }else{
      switch(selectType){
        default: case "date":
          this.setState({
            selectedDate: date.toISOString()
          }, this._afterSelect);
          break;
        case "week":
          this.setState({
            selectedStart: ZTime.StartOfWeek(date, null).toISOString(),
            selectedEnd: ZTime.EndOfWeek(date, null).toISOString()
          }, this._afterSelect);
          break;
        case "month":
          this.setState({
            selectedStart: ZTime.StartOfMonth(date, null).toISOString(),
            selectedEnd: ZTime.EndOfMonth(date, null).toISOString()
          }, this._afterSelect);
          break;
        case "year":
          this.setState({
            selectedStart: ZTime.StartOfYear(date, null).toISOString(),
            selectedEnd: ZTime.EndOfYear(date, null).toISOString()
          }, this._afterSelect);
          break;
      }   
    }
  };

  _onYearTextPress = () => {
    let {coreMode} = this.state;
    this.setState({
      coreMode: coreMode === "year" ? "date" : "year"
    });
  };

  _onMonthTextPress = () => {
    let {coreMode} = this.state;
    this.setState({
      coreMode: coreMode === "month" ? "date" : "month"
    });
  };

  toLastMonth = () => {
    let {disMonth, disYear} = this.state;
    if(disMonth === 0) { 
      disMonth = 11;
      disYear -= 1;
    }else{
      disMonth -= 1;
    }
    this._onSelectorChange(disYear, disMonth);
  };

  toNextMonth = () => {
    let {disMonth, disYear} = this.state;
    if(disMonth === 11) { 
      disMonth = 0;
      disYear += 1;
    }else{
      disMonth += 1;
    }
    this._onSelectorChange(disYear, disMonth);
  };

  renderCore(){
    let {dayCellDecorator} = this.props;
    let {disMonth, disYear, coreMode, rangeMode,
      selectedDate, selectedStart, selectedEnd, selectedDates} = this.state;
    
    switch(coreMode){
      default: case "date": return (
        <DateCore 
          disMonth={disMonth}
          disYear={disYear}
          rangeMode={rangeMode}
          _isValid={this._isValid}
          _onDateSelect={this._onDateSelect}
          _onSelectorChange={this._onSelectorChange}
          selectedDate={selectedDate}
          selectedStart={selectedStart}
          selectedEnd={selectedEnd}
          selectedDates={selectedDates}
          styles={this._GetStyle()}
          dayCellDecorator={dayCellDecorator}
          {...this.props}
          />
      );
      case "month": return (
        <MonthCore
          disYear={disYear}
          disMonth={disMonth}
          _isValidMonth={this._isValidMonth}
          _onSelectorChange={this._onSelectorChange}
          styles={this._GetStyle()}
          {...this.props}
          />
      );
      case "year": return (
        <YearCore
          disYear={disYear}
          disMonth={disMonth}
          _isValidYear={this._isValidYear}
          _onSelectorChange={this._onSelectorChange}
          styles={this._GetStyle()}
          {...this.props}
          />
      );
    }
  }

  render(){
    let {disMonth, disYear} = this.state;
    let {size, directConfirm, style, multiple} = this.props;
    return (
      <VStack width={Math.round(size * 7)} 
        style={{...this._GetStyle().mainContainer(size), ...style}}
        noPropagation>
        <VStack width={Math.round(size * 7)} 
          style={{...this._GetStyle().innerContainer(size)}}>
          <YearMonthSelector
            disYear={disYear}
            disMonth={disMonth}
            _isValid={this._isValid}
            _isValidMonth={this._isValidMonth}
            _isValidYear={this._isValidYear}
            _onSelectorChange={this._onSelectorChange}
            _onYearTextPress={this._onYearTextPress}
            _onMonthTextPress={this._onMonthTextPress}
            styles={this._GetStyle()}
            {...this.props}
            />
          <VStack height={Math.round(size * 6.75)} VAlign="-">
            {this.renderCore()}
          </VStack>
        </VStack>
        {(!directConfirm || multiple) && 
          <OperBar onConfirm={this._onConfirm} onCancel={this._onCancel}/>
        }
      </VStack>
    );
  }

}

export default observer(CalendarizoC);
